import { createContext } from 'react';
import type { Culture } from './widgetMessages';

type CommunicationContext = {
  userAccessToken: string;
  culture: Culture;
};

export default createContext<CommunicationContext | null>(null);
